import { AugmentedEsriToken } from "./useEsriToken"
import { PORTAL_URL } from "./constants"
import decode from "jwt-decode"
import { API } from "aws-amplify"

/** Handle registering the token with esri.IdentityManager */
export const handleRegisterEsriToken = (
  esriResponse: any,
  IdentityManager: __esri.IdentityManager
) => {
  /** Generate token object to register and store */
  const token = {
    expires: esriResponse.expires_in,
    server: PORTAL_URL + "/sharing/rest",
    ssl: true,
    token: esriResponse.access_token,
    userId: esriResponse.username,
  }

  /** Register token with esri IdentityManager */
  IdentityManager.registerToken(token)

  return {
    ...token,
    // set expires_at to 90% of the expiry time so we can refresh it
    expires_at: Date.now() - esriResponse.expires_in * 0.9 * 1000,
    refresh_token: esriResponse.refresh_token,
  }
}

/** Build the openID token for AWS */
export const buildOpenIDToken = (oidToken: any) => {
  const { exp } = decode<{ exp: any }>(oidToken.Token)
  return {
    identity_id: oidToken.IdentityId,
    token: oidToken.Token,
    expires_at: exp,
  }
}

/**
 * Handle esri refresh token
 * Careful - it throws the catch again
 */
export const getRefreshToken = (
  esriToken: AugmentedEsriToken,
  IdentityManager: __esri.IdentityManager
) => {
  const { refresh_token, userId } = esriToken
  return API.get("featureeditorstorageapi", "/token", {
    queryStringParameters: {
      refresh_token,
      grant_type: "refresh_token",
      redirect_uri: window.location.origin + "#",
      userId,
    },
  })
    .then(({ esriResponse, oidToken }) => {
      /** Firstly clear the current token */
      IdentityManager.destroyCredentials()

      /** Return oidToken for Amplify Auth */
      return { esriResponse, oidToken }
    })
    .catch((error) => {
      console.log(error)
      IdentityManager.destroyCredentials()
      /** Re-throw the error so it's catchable again */
      throw error
    })
}
